export enum SignRequestType {
  User = 'user',
  Portal = 'portal',
  Customer = 'customer',
}
